<template>
  <div>
    <div
      v-if="hasCertificate"
      class="flex items-center"
    >
      <svg
        width="20"
        height="24"
        preserveAspectRatio="xMidYMid"
        viewBox="0 0 256 310"
      >
        <path
          d="M73.871 282.05l54.097 27.051 5.284-3.942-2.224-301.561L127.968 0 73.871 27.051V282.05"
          fill="#9D5025"
        />
        <path
          d="M182.065 282.05l-54.097 27.051V0l54.097 27.051V282.05"
          fill="#F68536"
        />
        <path
          d="M107.571 112.513l-18.984 2.764L0 105.296l.375-.983L14.75 100l1.529.866.346-.866L107 110.563l.571 1.95"
          fill="#6B3A19"
        />
        <path
          d="M0 63.988l16.279-8.144v45.022L0 105.296V63.988"
          fill="#9D5025"
        />
        <path
          d="M256 131.063l-90.661 4.869-16.975-1.164 3.198-1.33 88.375-5.063L256 131.063"
          fill="#6B3A19"
        />
        <path
          d="M107.571 112.513l-91.292-11.647V55.844l91.292 21.414v35.255"
          fill="#F68536"
        />
        <path
          d="M239.656 82.225l-91.292 15.691v36.852l91.292-5.478.531-1.04L240 83.063l-.344-.838"
          fill="#9D5025"
        />
        <path
          d="M256 131.063l-16.344-2.125V82.225L256 88.21v42.853"
          fill="#F68536"
        />
      </svg>

      <mia-streamline-icon
        class="w-5 h-5 ml-2 text-green-500 fill-current"
        src="check-double"
      />
    </div>
    <mia-button
      v-else
      class="inline-flex items-center px-3 py-2 ml-2 text-gray-700 border-2 rounded-sm border-orange-mia focus:outline-none"
      :class="{
        'is-loading': $wait.is(loaderName),
        'hover:bg-orange-mia hover:text-white': !$wait.is(loaderName)
      }"
      :disabled="$wait.is(loaderName)"
      title="Zertifikat für diese Domain anfragen"
      @click.native="requestCertificate"
    >
      <template v-if="$wait.is(loaderName)">
        <mia-wave-loader size="small" />

        <span class="ml-2">
          wird angefragt…
        </span>
      </template>
      <template v-else>
        <svg
          width="20"
          height="24"
          preserveAspectRatio="xMidYMid"
          viewBox="0 0 256 310"
        >
          <path
            d="M73.871 282.05l54.097 27.051 5.284-3.942-2.224-301.561L127.968 0 73.871 27.051V282.05"
            fill="#9D5025"
          />
          <path
            d="M182.065 282.05l-54.097 27.051V0l54.097 27.051V282.05"
            fill="#F68536"
          />
          <path
            d="M107.571 112.513l-18.984 2.764L0 105.296l.375-.983L14.75 100l1.529.866.346-.866L107 110.563l.571 1.95"
            fill="#6B3A19"
          />
          <path
            d="M0 63.988l16.279-8.144v45.022L0 105.296V63.988"
            fill="#9D5025"
          />
          <path
            d="M256 131.063l-90.661 4.869-16.975-1.164 3.198-1.33 88.375-5.063L256 131.063"
            fill="#6B3A19"
          />
          <path
            d="M107.571 112.513l-91.292-11.647V55.844l91.292 21.414v35.255"
            fill="#F68536"
          />
          <path
            d="M239.656 82.225l-91.292 15.691v36.852l91.292-5.478.531-1.04L240 83.063l-.344-.838"
            fill="#9D5025"
          />
          <path
            d="M256 131.063l-16.344-2.125V82.225L256 88.21v42.853"
            fill="#F68536"
          />
        </svg>

        <span class="ml-2">
          Anfragen
        </span>
      </template>
    </mia-button>
  </div>
</template>

<script>
import { requestCertificate } from '@/api/websiteOnboarding'

export default {
  name: 'MiaDatatableCertificateColumn',

  props: {
    row: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      hasCertificate: this.row.HasCertificate
    }
  },

  computed: {
    loaderName() {
      return `requesting certificate for ${this.row.DomainName}`
    }
  },

  methods: {
    async requestCertificate() {
      this.$wait.start(this.loaderName)

      try {
        await requestCertificate(this.row.DomainName)

        this.hasCertificate = true

        eventBus.$emit('mia-info', {
          info: ['Zertifikat wurde erfolgreich angefragt.']
        })
      } catch (e) {
        console.log(e)

        eventBus.$emit('mia-error', {
          error: ['Zertifikat konnte nicht angefragt werden.']
        })
      } finally {
        this.$wait.end(this.loaderName)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.is-loading {
  @apply cursor-wait #{!important};
}
</style>
